(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puppath-breed-matches"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('puppath-similar-pups')) {
    class PupPathSimilarPups extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this._life = new AbortController();
        this._cache = new Map();
        this._sequence = 0;
        try {
          this.config = JSON.parse(this.querySelector('[data-ppsr-config]').content.textContent);
        } catch (_) {
          this.status('The recommendation settings could not be read. Re-paste the complete section file.');
          return;
        }
        this.catalog = new Map(this.config.catalog.map(breed => [breed.key, breed]));
        this.editor = this.dataset.designMode === 'true' || Boolean(window.Shopify?.designMode);
        const root = new URL(this.dataset.shopRoot || window.Shopify?.routes?.root || '/', location.origin);
        this.shopRoot = root.origin === location.origin ? root : new URL('/', location.origin);
        if (!this.shopRoot.pathname.endsWith('/')) this.shopRoot.pathname += '/';
        const signal = this._life.signal;
        window.addEventListener('popstate', () => { this._editorBreed = ''; this.refresh(); }, {signal});
        window.addEventListener('pageshow', event => { if (event.persisted) { this._cache.clear(); this.refresh(); } }, {signal});
        document.addEventListener('shopify:section:load', () => { if (this.editor) { this._editorBreed = ''; queueMicrotask(() => this.refresh()); } }, {signal});
        document.addEventListener('shopify:block:select', event => {
          if (!this.editor || this.config.mode === 'product') return;
          const host = this.sourceHost();
          const breed = host?.catalog?.find(item => item.id === event.detail?.blockId);
          if (breed) { this._editorBreed = breed.key; this.refresh(); }
        }, {signal});
        this.refresh();
      }

      disconnectedCallback() {
        this._connected = false;
        this._life?.abort();
        this._loading?.abort();
        this._sequence = (this._sequence || 0) + 1;
      }

      status(message) {
        const element = this.querySelector('[data-ppsr-status]');
        if (!element) return;
        element.textContent = message;
        element.hidden = !message;
      }

      sourceHost() {
        return document.querySelector(this.config.funnel === 'save-now' ? 'puppath-save-puppies' : 'puppath-find-puppies');
      }

      normalize(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }

      selectedBreed() {
        if (this.config.mode === 'product') {
          const tags = Array.isArray(this.config.productTags) ? this.config.productTags : [];
          return this.config.catalog.find(breed => tags.includes(breed.key));
        }
        const host = this.sourceHost();
        let requested = this._editorBreed || new URL(location.href).searchParams.get('breed');
        if (!requested && this.editor) requested = host?._view?.breed?.key || host?.dataset.previewBreed || this.config.previewBreed;
        const normalized = this.normalize(requested);
        if (!normalized) return null;
        const direct = this.config.catalog.find(breed => this.normalize(breed.key) === normalized || this.normalize(breed.name) === normalized);
        if (direct) return direct;
        const alias = host?.catalog?.find(breed => String(breed.aliases || '').split(',').some(value => this.normalize(value) === normalized));
        return alias ? this.catalog.get(alias.key) : null;
      }

      localURL(value, kind) {
        if (!value) return null;
        try {
          const url = new URL(value, this.shopRoot);
          if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
          if (!url.pathname.includes('/' + kind + '/')) return null;
          if (this.shopRoot.pathname !== '/' && !url.pathname.startsWith(this.shopRoot.pathname)) {
            url.pathname = this.shopRoot.pathname + url.pathname.replace(/^\/+/, '');
          }
          return url;
        } catch (_) { return null; }
      }

      async loadBreed(breed, signal) {
        if (this._cache.has(breed.key)) return this._cache.get(breed.key);
        const url = this.localURL(breed.url, 'collections');
        if (!url) return [];
        url.search = '';
        url.searchParams.set('sections', this.dataset.sectionId);
        const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
        if (previewTheme && /^\d+$/.test(previewTheme)) url.searchParams.set('preview_theme_id', previewTheme);
        const controller = new AbortController();
        const abort = () => controller.abort();
        signal.addEventListener('abort', abort, {once:true});
        if (signal.aborted) controller.abort();
        const timeout = setTimeout(abort, 12000);
        try {
          // Keep the normal page request format: application/json selects
          // collection metadata instead of section HTML on Shopify's route.
          const response = await fetch(url.href, {credentials:'same-origin', cache:'no-store', signal:controller.signal});
          if (!response.ok) throw new Error('Collection request failed');
          const sections = await response.json();
          const markup = sections[this.dataset.sectionId];
          if (typeof markup !== 'string') throw new Error('Section not available');
          const parsed = new DOMParser().parseFromString(markup, 'text/html');
          const feed = parsed.querySelector('template[data-ppsr-feed]');
          if (!feed) throw new Error('Collection feed missing');
          const data = JSON.parse(feed.content.textContent);
          if (!Array.isArray(data.products)) throw new Error('Collection feed invalid');
          const otherFunnel = this.config.funnel === 'find-now' ? 'save-now' : 'find-now';
          const products = data.products.filter(pup => {
            if (!pup || !pup.id || pup.available !== true || !Array.isArray(pup.tags)) return false;
            if (!pup.tags.includes(this.config.funnel) || pup.tags.includes(otherFunnel) || !pup.tags.includes(breed.key)) return false;
            if (this.config.mode === 'product' && String(pup.id) === String(this.config.productId)) return false;
            return typeof pup.image === 'string' && pup.image.includes('<img') && typeof pup.price === 'string' && this.localURL(pup.url, 'products');
          }).map(pup => ({...pup, breed:breed.key}));
          if (!signal.aborted) this._cache.set(breed.key, products);
          return products;
        } finally {
          clearTimeout(timeout);
          signal.removeEventListener('abort', abort);
        }
      }

      async refresh() {
        if (!this.config || !this.isConnected) return;
        const sequence = ++this._sequence;
        this._loading?.abort();
        this._loading = new AbortController();
        const signal = this._loading.signal;
        const view = this.querySelector('[data-ppsr-view]');
        view.hidden = true;
        this.setAttribute('aria-busy', 'true');
        const selected = this.selectedBreed();
        if (!['find-now', 'save-now'].includes(this.config.funnel) || !selected) {
          this.setAttribute('aria-busy', 'false');
          this.status(this.config.mode === 'product' ? 'Choose a product with its breed tag and either find-now or save-now. The section stays hidden for customers when no breed is identified.' : 'Open this puppy page with a selected breed. In the editor, select a breed block above or set Preview breed. If the page was renamed, choose its Page funnel here.');
          return;
        }
        const order = this.config.mode === 'product' ? [selected.key, ...selected.related] : selected.related.filter(key => key !== selected.key);
        const candidates = [...new Set(order)].map(key => this.catalog.get(key)).filter(breed => breed && breed.url);
        this.status('Loading your breed recommendations…');
        const seen = new Set();
        const chosen = [];
        let failures = 0;
        // Two requests at a time; processing stays in the configured breed order.
        for (let start = 0; start < candidates.length && chosen.length < 8; start += 2) {
          const batch = await Promise.allSettled(candidates.slice(start, start + 2).map(breed => this.loadBreed(breed, signal)));
          if (signal.aborted || sequence !== this._sequence || !this.isConnected) return;
          for (const result of batch) {
            if (result.status !== 'fulfilled') { failures++; continue; }
            for (const pup of result.value) {
              if (chosen.length >= 8) break;
              const id = String(pup.id);
              if (seen.has(id)) continue;
              // Enforce exclusion even if a product was accidentally given two breed tags.
              if (this.config.mode === 'breeds' && pup.tags.includes(selected.key)) continue;
              const card = this.makeCard(pup);
              if (!card) continue;
              seen.add(id);
              chosen.push(card);
            }
          }
        }
        if (signal.aborted || sequence !== this._sequence || !this.isConnected) return;
        this.querySelector('[data-ppsr-heading]').textContent = this.replaceBreed(this.config.heading, selected.name);
        this.querySelector('[data-ppsr-row-one]').replaceChildren(...chosen.slice(0, 4));
        this.querySelector('[data-ppsr-row-two]').replaceChildren(...chosen.slice(4, 8));
        this.querySelector('[data-ppsr-divider]').hidden = chosen.length <= 4;
        this.querySelector('[data-ppsr-second]').hidden = chosen.length <= 4;
        view.hidden = chosen.length === 0;
        this.setAttribute('aria-busy', 'false');
        if (!candidates.length) this.status('No published collection matched ' + selected.name + ' or its related breeds in this funnel. Check the breed collections\' Online Store channel and titles. Existing custom collection URLs can stay unchanged.');
        else if (!chosen.length) this.status(failures ? 'The breed collections could not be loaded. Check that this complete section is saved in the same theme and the collections are published to Online Store.' : 'No other eligible pups with photos were found. Customers will not see an empty recommendation section.');
        else if (failures) this.status('Some collections could not load. The available matches are shown; refresh to retry.');
        else if (chosen.length < 8) this.status(chosen.length + ' eligible pups found. This section displays up to 8 unique available pups, without repeating products.');
        else this.status('');
      }

      replaceBreed(text, name) { return String(text || '').replace(/\[breed\]|\(breed\)/gi, name); }

      makeCard(pup) {
        const breed = this.catalog.get(pup.breed);
        const url = this.localURL(pup.url, 'products');
        if (!breed || !url) return null;
        const imageTemplate = document.createElement('template');
        imageTemplate.innerHTML = pup.image;
        const sourceImage = imageTemplate.content.querySelector('img');
        if (!sourceImage) return null;
        let imageURL;
        try { imageURL = new URL(sourceImage.getAttribute('src'), location.origin); } catch (_) { return null; }
        if (!/^https?:$/.test(imageURL.protocol)) return null;
        const item = document.createElement('li');
        item.className = 'ppsr__item';
        item.dataset.productId = String(pup.id);
        item.dataset.breed = breed.key;
        const link = document.createElement('a');
        link.className = 'ppsr__card';
        link.href = url.href;
        link.setAttribute('aria-label', 'View ' + pup.title + ', ' + breed.name);
        const photo = document.createElement('div');
        photo.className = 'ppsr__photo';
        const image = document.createElement('img');
        image.className = 'ppsr__image';
        image.src = imageURL.href;
        for (const attribute of ['srcset', 'sizes', 'width', 'height']) {
          const value = sourceImage.getAttribute(attribute);
          if (value) image.setAttribute(attribute, value);
        }
        image.alt = pup.title + ' — ' + breed.name;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.style.objectPosition = sourceImage.style.objectPosition || '50% 50%';
        photo.append(image);
        const price = document.createElement('p');
        price.className = 'ppsr__price';
        price.textContent = (pup.priceVaries ? 'From ' : '') + pup.price;
        const copy = document.createElement('p');
        copy.className = 'ppsr__copy';
        copy.textContent = this.replaceBreed(this.config.copy, breed.name);
        const button = document.createElement('span');
        button.className = 'ppsr__button';
        button.textContent = 'Look at the ' + breed.name;
        link.append(photo, price, copy, button);
        item.append(link);
        return item;
      }
    }
    customElements.define('puppath-similar-pups', PupPathSimilarPups);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puppath-find-randomizer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('puppath-find-randomizer')) {
    const breedNames = new Map(Object.entries({
      "german-shepherd": "German Shepherd",
      "golden-retriever": "Golden Retriever",
      "labrador-retriever": "Labrador Retriever",
      "otterhound": "Otterhound",
      "pomeranian": "Pomeranian",
      "french-bulldog": "French Bulldog",
      "dachshund": "Dachshund",
      "poodle": "Poodle",
      "beagle": "Beagle",
      "rottweiler": "Rottweiler",
      "german-shorthaired-pointer": "German Shorthaired Pointer",
      "bulldog": "Bulldog",
      "cane-corso": "Cane Corso",
      "cavalier-king-charles-spaniel": "Cavalier King Charles Spaniel",
      "yorkshire-terrier": "Yorkshire Terrier",
      "australian-shepherd": "Australian Shepherd",
      "doberman-pinscher": "Doberman Pinscher",
      "pembroke-welsh-corgi": "Pembroke Welsh Corgi",
      "miniature-schnauzer": "Miniature Schnauzer",
      "boxer": "Boxer",
      "bernese-mountain-dog": "Bernese Mountain Dog",
      "shih-tzu": "Shih Tzu",
      "great-dane": "Great Dane",
      "boston-terrier": "Boston Terrier",
      "chihuahua": "Chihuahua",
      "havanese": "Havanese",
      "border-collie": "Border Collie",
      "english-springer-spaniel": "English Springer Spaniel",
      "miniature-american-shepherd": "Miniature American Shepherd",
      "shetland-sheepdog": "Shetland Sheepdog",
      "siberian-husky": "Siberian Husky",
      "brittany": "Brittany",
      "belgian-malinois": "Belgian Malinois",
      "cocker-spaniel": "Cocker Spaniel",
      "basset-hound": "Basset Hound",
      "english-cocker-spaniel": "English Cocker Spaniel",
      "vizsla": "Vizsla",
      "maltese": "Maltese",
      "pug": "Pug",
      "collie": "Collie",
      "mastiff": "Mastiff",
      "rhodesian-ridgeback": "Rhodesian Ridgeback",
      "papillon": "Papillon",
      "portuguese-water-dog": "Portuguese Water Dog",
      "shiba-inu": "Shiba Inu"
}));

    class PupPathFindRandomizer extends HTMLElement {
      connectedCallback() {
        if (this._running) return;
        this._running = true;
        this.controller = new AbortController();
        this.spinButton = this.querySelector('[data-pfr-spin]');
        this.statusText = this.querySelector('[data-pfr-status]');
        this.card = this.querySelector('[data-pfr-card]');
        this.heading = this.querySelector('[data-pfr-heading]');
        this.nameText = this.querySelector('[data-pfr-name]');
        this.mystery = this.querySelector('[data-pfr-mystery]');
        this.photo = this.querySelector('[data-pfr-photo]');
        this.photoFallback = this.querySelector('[data-pfr-photo-fallback]');
        this.productLink = this.querySelector('[data-pfr-link]');
        this.bottomStem = this.querySelector('[data-pfr-bottom-stem]');
        if (!this.spinButton || !this.card) { this._running = false; return; }
        this.spinButton.addEventListener('click', () => {
          if (this.failed) this.loadCatalog();
          else this.revealNext();
        }, { signal: this.controller.signal });
        this.productLink.addEventListener('click', event => {
          if (this.busy) event.preventDefault();
        }, { signal: this.controller.signal });
        this.photo.addEventListener('error', () => {
          this.photo.hidden = true;
          this.mystery.hidden = false;
          this.photoFallback.hidden = false;
        }, { signal: this.controller.signal });
        this.loadCatalog();
      }

      disconnectedCallback() {
        this._running = false;
        if (this.controller) this.controller.abort();
        this.loading = false;
        this.busy = false;
        if (this.card) this.card.getAnimations().forEach(animation => animation.cancel());
      }

      async loadCatalog() {
        if (this.loading) return;
        this.loading = true;
        this.failed = false;
        this.breedErrors = [];
        this.spinButton.disabled = true;
        this.spinButton.textContent = 'FIND MY MATCH';
        this.statusText.removeAttribute('data-pfr-progress');
        this.statusText.textContent = 'Getting the pups ready…';
        const signal = this.controller.signal;
        try {
          const first = JSON.parse(this.querySelector('[data-pfr-catalog]').textContent);
          if (!first.collectionId) {
            this.statusText.textContent = this.dataset.editor === 'true'
              ? 'Select your Find Now — All Pups collection in this section’s settings.'
              : 'Pups are on their way. Please check back soon.';
            return;
          }
          if (!Array.isArray(first.products) || !Number.isInteger(first.pages) || first.pages < 0 || first.pages > 500) throw new Error('Invalid catalog');
          const all = new Map();
          const pages = Math.max(1, first.pages);
          for (let page = 1; page <= pages; page++) {
            const payload = page === first.page ? first : await this.fetchPage(page, first, signal);
            for (const pup of payload.products) {
              if (!pup || typeof pup.id !== 'string' || typeof pup.title !== 'string' || !pup.title) continue;
              const destination = new URL(pup.url, window.location.origin);
              if (destination.origin !== window.location.origin || !destination.pathname.includes('/products/')) continue;
              const breed = this.resolveBreed(pup);
              if (!breed) {
                this.breedErrors.push(pup.title + ' (' + (pup.handle || pup.id) + ')');
                continue;
              }
              all.set(pup.id, { ...pup, ...breed, url: destination.href });
            }
          }
          if (signal.aborted) return;
          if (this.breedErrors.length) throw new Error('Breed data needs attention');
          this.pups = Array.from(all.values());
          this.breeds = new Map();
          for (const pup of this.pups) {
            if (!this.breeds.has(pup.breedKey)) this.breeds.set(pup.breedKey, []);
            this.breeds.get(pup.breedKey).push(pup);
          }
          if (!this.pups.length) {
            this.statusText.textContent = this.dataset.editor === 'true'
              ? 'No Find Now pups found. Include the find-now tag in this collection and publish it and its products to Online Store.'
              : 'There are no pups to show here yet. Please check back soon.';
            return;
          }
          this.storageKey = 'puppath-find-randomizer-rounds-v1:' + first.collectionId;
          this.restoreProgress();
          this.spinButton.disabled = false;
        } catch (error) {
          if (signal.aborted) return;
          this.failed = true;
          this.spinButton.disabled = false;
          this.spinButton.textContent = 'TRY AGAIN';
          this.statusText.textContent = this.dataset.editor === 'true'
            ? (this.breedErrors.length
              ? 'Check the breed tag for: ' + this.breedErrors.slice(0, 3).join('; ') + '. Each pup needs one recognized breed tag, or a matching Find Now breed collection/imported handle. No partial list has been started.'
              : 'The full puppy list could not load. Save the section and collection selection, check Online Store publication, then try again in storefront Preview.')
            : 'The pups could not load just now. Please try again.';
        } finally {
          if (this.controller.signal === signal) this.loading = false;
        }
      }

      async fetchPage(page, initial, parentSignal) {
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set(initial.pageParam || 'page', String(page));
        const request = new AbortController();
        const abort = () => request.abort();
        parentSignal.addEventListener('abort', abort, { once: true });
        const timeout = setTimeout(abort, 15000);
        try {
          if (parentSignal.aborted) throw new Error('Aborted');
          const response = await fetch(url.href, { credentials: 'same-origin', signal: request.signal });
          if (!response.ok) throw new Error('Section request failed');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const instance = Array.from(documentFragment.querySelectorAll('puppath-find-randomizer'))
            .find(element => element.dataset.sectionId === this.dataset.sectionId);
          const data = instance && instance.querySelector('[data-pfr-catalog]');
          if (!data) throw new Error('Section data missing');
          const payload = JSON.parse(data.textContent);
          if (payload.collectionId !== initial.collectionId || payload.page !== page || payload.pages !== initial.pages || !Array.isArray(payload.products)) throw new Error('Catalog changed');
          return payload;
        } finally {
          clearTimeout(timeout);
          parentSignal.removeEventListener('abort', abort);
        }
      }

      breedKey(value) {
        return String(value || '').trim().toLowerCase().replace(/[’']/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      }

      resolveBreed(pup) {
        const tags = new Set((Array.isArray(pup.tags) ? pup.tags : []).map(tag => this.breedKey(tag)));
        const known = Array.from(breedNames.keys()).filter(key => tags.has(key));
        if (known.length === 1) return { breedKey: known[0], breed: breedNames.get(known[0]) };
        if (known.length > 1) return null;

        // Preserve the name from a matching breed collection, including any new
        // breeds added later. The aggregate All Pups collection is never a breed.
        const matches = new Map();
        for (const collection of Array.isArray(pup.breedCollections) ? pup.breedCollections : []) {
          const key = String(collection.handle || '').replace(/^find-now-/, '');
          const title = String(collection.title || '').match(/^Find\s+Now\s*[-–—:]\s*(.+)$/i);
          if (title && tags.has(key) && this.breedKey(title[1]) === key) matches.set(key, title[1].trim());
        }
        if (matches.size === 1) {
          const [key, title] = matches.entries().next().value;
          return { breedKey: key, breed: breedNames.get(key) || title };
        }
        if (matches.size > 1) return null;

        // Existing imports use find-now-BREED-01. For a new breed not in the
        // built-in list, require its matching tag rather than guessing a name.
        const imported = String(pup.handle || '').match(/^find-now-(.+)-[0-9]+$/);
        if (imported && (breedNames.has(imported[1]) || tags.has(imported[1]))) {
          const key = imported[1];
          return { breedKey: key, breed: breedNames.get(key) || key.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') };
        }
        return null;
      }

      restoreProgress() {
        let saved = {};
        try { saved = JSON.parse(sessionStorage.getItem(this.storageKey) || '{}') || {}; } catch (error) { /* Storage is optional. */ }
        const current = new Set(this.pups.map(pup => pup.id));
        this.seen = new Set(Array.isArray(saved.seen) ? saved.seen.filter(id => current.has(id)) : []);
        this.roundSeen = new Set(Array.isArray(saved.roundSeen) ? saved.roundSeen.filter(key => this.breeds.has(key)) : []);
        this.lastId = typeof saved.lastId === 'string' && this.seen.has(saved.lastId) ? saved.lastId : '';
        if (this.lastId) this.paint(this.pups.find(pup => pup.id === this.lastId));
        this.updateStatus();
      }

      saveProgress() {
        try {
          sessionStorage.setItem(this.storageKey, JSON.stringify({ seen: Array.from(this.seen), roundSeen: Array.from(this.roundSeen), lastId: this.lastId }));
        } catch (error) { /* Continue within this page if storage is blocked. */ }
      }

      chooseNext() {
        if (this.seen.size === this.pups.length) {
          this.seen.clear();
          this.roundSeen.clear();
        }
        const unseen = Array.from(this.breeds, ([key, pups]) => ({ key, pups: pups.filter(pup => !this.seen.has(pup.id)) }))
          .filter(group => group.pups.length);
        let eligible = unseen.filter(group => !this.roundSeen.has(group.key));
        if (!eligible.length) {
          this.roundSeen.clear();
          eligible = unseen;
        }
        // Avoid the same breed on both sides of a round boundary when possible.
        const previous = this.pups.find(pup => pup.id === this.lastId);
        if (!this.roundSeen.size && eligible.length > 1 && previous) {
          eligible = eligible.filter(group => group.key !== previous.breedKey);
        }
        const group = eligible[Math.floor(Math.random() * eligible.length)];
        if (!group) return null;
        const alternatives = group.pups.filter(pup => pup.id !== this.lastId);
        const candidates = alternatives.length ? alternatives : group.pups;
        return candidates[Math.floor(Math.random() * candidates.length)];
      }

      updateStatus() {
        this.statusText.setAttribute('data-pfr-progress', '');
        const done = this.seen.size;
        const total = this.pups.length;
        this.spinButton.textContent = done === total ? 'START AGAIN' : done ? 'SPIN AGAIN' : 'FIND MY MATCH';
        this.statusText.textContent = done === total
          ? 'You’ve met all ' + total + (total === 1 ? ' pup. ' : ' pups. ') + 'Start again for a fresh shuffle.'
          : done ? 'Pups met: ' + done + ' of ' + total : 'Click to meet your first pup.';
      }

      paint(pup) {
        this.heading.hidden = false;
        this.nameText.textContent = 'This ' + pup.title + ' Chose You';
        this.productLink.textContent = 'Look at ' + pup.breed;
        this.productLink.setAttribute('aria-label', 'Look at ' + pup.breed + ' pup: ' + pup.title);
        this.productLink.href = pup.url;
        this.productLink.hidden = false;
        this.bottomStem.hidden = true;
        this.photo.hidden = true;
        this.photoFallback.hidden = true;
        if (pup.image) {
          this.photo.alt = pup.title + ' — ' + pup.breed;
          this.photo.src = pup.image;
          this.photo.hidden = false;
          this.mystery.hidden = true;
        } else {
          this.photo.removeAttribute('src');
          this.mystery.hidden = false;
          this.photoFallback.hidden = false;
        }
      }

      async turn(from, to, duration) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !this.card.animate) return;
        const animation = this.card.animate([
          { transform: 'rotateY(' + from + 'deg)' },
          { transform: 'rotateY(' + to + 'deg)' }
        ], { duration, easing: 'ease-in-out', fill: 'forwards' });
        try { await animation.finished; } catch (error) { /* Section removed during a flip. */ }
      }

      async revealNext() {
        if (this.busy || this.loading || !this.pups || !this.pups.length) return;
        this.busy = true;
        this.spinButton.disabled = true;
        this.card.setAttribute('aria-busy', 'true');
        this.productLink.setAttribute('aria-disabled', 'true');
        const signal = this.controller.signal;
        try {
          const pup = this.chooseNext();
          if (!pup) return;
          await this.turn(0, 90, 240);
          if (signal.aborted) return;
          this.card.getAnimations().forEach(animation => animation.cancel());
          this.paint(pup);
          await this.turn(-90, 0, 300);
          if (signal.aborted) return;
          this.seen.add(pup.id);
          this.roundSeen.add(pup.breedKey);
          this.lastId = pup.id;
          this.saveProgress();
          this.updateStatus();
        } finally {
          if (this.controller.signal === signal) {
            this.card.getAnimations().forEach(animation => animation.cancel());
            this.card.removeAttribute('aria-busy');
            this.productLink.removeAttribute('aria-disabled');
            this.busy = false;
            if (!signal.aborted) this.spinButton.disabled = false;
          }
        }
      }
    }
    customElements.define('puppath-find-randomizer', PupPathFindRandomizer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puppath-home-randomizer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('puppath-home-randomizer')) {
    const breedNames = new Map(Object.entries({
      "german-shepherd": "German Shepherd",
      "golden-retriever": "Golden Retriever",
      "labrador-retriever": "Labrador Retriever",
      "otterhound": "Otterhound",
      "pomeranian": "Pomeranian",
      "french-bulldog": "French Bulldog",
      "dachshund": "Dachshund",
      "poodle": "Poodle",
      "beagle": "Beagle",
      "rottweiler": "Rottweiler",
      "german-shorthaired-pointer": "German Shorthaired Pointer",
      "bulldog": "Bulldog",
      "cane-corso": "Cane Corso",
      "cavalier-king-charles-spaniel": "Cavalier King Charles Spaniel",
      "yorkshire-terrier": "Yorkshire Terrier",
      "australian-shepherd": "Australian Shepherd",
      "doberman-pinscher": "Doberman Pinscher",
      "pembroke-welsh-corgi": "Pembroke Welsh Corgi",
      "miniature-schnauzer": "Miniature Schnauzer",
      "boxer": "Boxer",
      "bernese-mountain-dog": "Bernese Mountain Dog",
      "shih-tzu": "Shih Tzu",
      "great-dane": "Great Dane",
      "boston-terrier": "Boston Terrier",
      "chihuahua": "Chihuahua",
      "havanese": "Havanese",
      "border-collie": "Border Collie",
      "english-springer-spaniel": "English Springer Spaniel",
      "miniature-american-shepherd": "Miniature American Shepherd",
      "shetland-sheepdog": "Shetland Sheepdog",
      "siberian-husky": "Siberian Husky",
      "brittany": "Brittany",
      "belgian-malinois": "Belgian Malinois",
      "cocker-spaniel": "Cocker Spaniel",
      "basset-hound": "Basset Hound",
      "english-cocker-spaniel": "English Cocker Spaniel",
      "vizsla": "Vizsla",
      "maltese": "Maltese",
      "pug": "Pug",
      "collie": "Collie",
      "mastiff": "Mastiff",
      "rhodesian-ridgeback": "Rhodesian Ridgeback",
      "papillon": "Papillon",
      "portuguese-water-dog": "Portuguese Water Dog",
      "shiba-inu": "Shiba Inu"
}));

    class PupPathHomeRandomizer extends HTMLElement {
      connectedCallback() {
        if (this._running) return;
        this._running = true;
        this.controller = new AbortController();
        this.spinButton = this.querySelector('[data-phr-spin]');
        this.statusText = this.querySelector('[data-phr-status]');
        this.card = this.querySelector('[data-phr-card]');
        this.heading = this.querySelector('[data-phr-heading]');
        this.nameText = this.querySelector('[data-phr-name]');
        this.mystery = this.querySelector('[data-phr-mystery]');
        this.photo = this.querySelector('[data-phr-photo]');
        this.photoFallback = this.querySelector('[data-phr-photo-fallback]');
        this.productLink = this.querySelector('[data-phr-link]');
        this.bottomStem = this.querySelector('[data-phr-bottom-stem]');
        if (!this.spinButton || !this.card) { this._running = false; return; }
        this.spinButton.addEventListener('click', () => {
          if (this.failed) this.loadCatalog();
          else this.revealNext();
        }, { signal: this.controller.signal });
        this.productLink.addEventListener('click', event => {
          if (this.busy) event.preventDefault();
        }, { signal: this.controller.signal });
        this.photo.addEventListener('error', () => {
          this.photo.hidden = true;
          this.mystery.hidden = false;
          this.photoFallback.hidden = false;
        }, { signal: this.controller.signal });
        this.loadCatalog();
      }

      disconnectedCallback() {
        this._running = false;
        if (this.controller) this.controller.abort();
        this.loading = false;
        this.busy = false;
        if (this.card) this.card.getAnimations().forEach(animation => animation.cancel());
      }

      async loadCatalog() {
        if (this.loading) return;
        this.loading = true;
        this.failed = false;
        this.catalogErrors = [];
        this.spinButton.disabled = true;
        this.spinButton.textContent = 'FIND MY MATCH';
        this.statusText.removeAttribute('data-phr-progress');
        this.statusText.textContent = 'Getting the pups ready…';
        const signal = this.controller.signal;
        try {
          const first = JSON.parse(this.querySelector('[data-phr-catalog]').textContent);
          if (!first.collectionId) {
            this.statusText.textContent = this.dataset.editor === 'true'
              ? 'Select your PupPath — All Pups collection in this section’s settings.'
              : 'Pups are on their way. Please check back soon.';
            return;
          }
          if (!Array.isArray(first.products) || !Number.isInteger(first.pages) || first.pages < 0 || first.pages > 500) throw new Error('Invalid catalog');
          const all = new Map();
          const pages = Math.max(1, first.pages);
          for (let page = 1; page <= pages; page++) {
            const payload = page === first.page ? first : await this.fetchPage(page, first, signal);
            for (const pup of payload.products) {
              if (!pup || typeof pup.id !== 'string' || typeof pup.title !== 'string' || !pup.title) continue;
              const destination = new URL(pup.url, window.location.origin);
              if (destination.origin !== window.location.origin || !destination.pathname.includes('/products/')) continue;
              const funnel = this.resolveFunnel(pup);
              const breed = funnel && this.resolveBreed(pup, funnel);
              if (!funnel || !breed) {
                this.catalogErrors.push(pup.title + ' (' + (pup.handle || pup.id) + '): ' + (!funnel ? 'check Find Now / Save Now tags' : 'check breed tag'));
                continue;
              }
              all.set(pup.id, { ...pup, ...breed, funnel, url: destination.href });
            }
          }
          if (signal.aborted) return;
          if (this.catalogErrors.length) throw new Error('Product data needs attention');
          this.pups = Array.from(all.values());
          this.byId = new Map(this.pups.map(pup => [pup.id, pup]));
          this.breeds = { find: new Map(), save: new Map() };
          for (const pup of this.pups) {
            const breeds = this.breeds[pup.funnel];
            if (!breeds.has(pup.breedKey)) breeds.set(pup.breedKey, []);
            breeds.get(pup.breedKey).push(pup);
          }
          if (!this.pups.length) {
            this.statusText.textContent = this.dataset.editor === 'true'
              ? 'No pups found. Include products tagged find-now OR save-now in this collection and publish it and its products to Online Store.'
              : 'There are no pups to show here yet. Please check back soon.';
            return;
          }
          this.storageKey = 'puppath-home-randomizer-2to1-v1:' + first.collectionId;
          this.restoreProgress();
          this.spinButton.disabled = false;
        } catch (error) {
          if (signal.aborted) return;
          this.failed = true;
          this.spinButton.disabled = false;
          this.spinButton.textContent = 'TRY AGAIN';
          this.statusText.textContent = this.dataset.editor === 'true'
            ? (this.catalogErrors.length
              ? 'Check product data: ' + this.catalogErrors.slice(0, 3).join('; ') + '. Use a Find Now or Save Now tag and one breed tag, or a matching breed collection/imported handle. No partial list has been started.'
              : 'The full puppy list could not load. Save the section and collection selection, check Online Store publication, then try again in storefront Preview.')
            : 'The pups could not load just now. Please try again.';
        } finally {
          if (this.controller.signal === signal) this.loading = false;
        }
      }

      async fetchPage(page, initial, parentSignal) {
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set(initial.pageParam || 'page', String(page));
        const request = new AbortController();
        const abort = () => request.abort();
        parentSignal.addEventListener('abort', abort, { once: true });
        const timeout = setTimeout(abort, 15000);
        try {
          if (parentSignal.aborted) throw new Error('Aborted');
          const response = await fetch(url.href, { credentials: 'same-origin', signal: request.signal });
          if (!response.ok) throw new Error('Section request failed');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const instance = Array.from(documentFragment.querySelectorAll('puppath-home-randomizer'))
            .find(element => element.dataset.sectionId === this.dataset.sectionId);
          const data = instance && instance.querySelector('[data-phr-catalog]');
          if (!data) throw new Error('Section data missing');
          const payload = JSON.parse(data.textContent);
          if (payload.collectionId !== initial.collectionId || payload.page !== page || payload.pages !== initial.pages || !Array.isArray(payload.products)) throw new Error('Catalog changed');
          return payload;
        } finally {
          clearTimeout(timeout);
          parentSignal.removeEventListener('abort', abort);
        }
      }

      breedKey(value) {
        return String(value || '').trim().toLowerCase().replace(/[’']/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      }

      resolveFunnel(pup) {
        const tags = Array.isArray(pup.tags) ? pup.tags : [];
        const find = tags.includes('find-now');
        const save = tags.includes('save-now');
        if (find !== save) return find ? 'find' : 'save';
        // An accidentally double-tagged import still belongs to one funnel.
        if (find && save) {
          const imported = String(pup.handle || '').match(/^(find|save)-now-/);
          if (imported) return imported[1];
        }
        return null;
      }

      resolveBreed(pup, funnel) {
        const tags = new Set((Array.isArray(pup.tags) ? pup.tags : []).map(tag => this.breedKey(tag)));
        const known = Array.from(breedNames.keys()).filter(key => tags.has(key));
        if (known.length === 1) return { breedKey: known[0], breed: breedNames.get(known[0]) };
        if (known.length > 1) return null;

        // Preserve the name from a matching breed collection, including any new
        // breeds added later. The aggregate All Pups collection is never a breed.
        const matches = new Map();
        for (const collection of Array.isArray(pup.breedCollections) ? pup.breedCollections : []) {
          const key = String(collection.handle || '').replace(/^(?:find|save)-now-/, '');
          const title = String(collection.title || '').match(/^(Find|Save)\s+Now\s*[-–—:]\s*(.+)$/i);
          if (title && title[1].toLowerCase() === funnel && tags.has(key) && this.breedKey(title[2]) === key) matches.set(key, title[2].trim());
        }
        if (matches.size === 1) {
          const [key, title] = matches.entries().next().value;
          return { breedKey: key, breed: breedNames.get(key) || title };
        }
        if (matches.size > 1) return null;

        // Existing imports use find-now-BREED-01 or save-now-BREED-01. For a breed outside the
        // built-in list, require its matching tag rather than guessing a name.
        const imported = String(pup.handle || '').match(/^(find|save)-now-(.+)-[0-9]+$/);
        if (imported && imported[1] === funnel && (breedNames.has(imported[2]) || tags.has(imported[2]))) {
          const key = imported[2];
          return { breedKey: key, breed: breedNames.get(key) || key.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') };
        }
        return null;
      }

      restoreProgress() {
        let saved = {};
        try { saved = JSON.parse(sessionStorage.getItem(this.storageKey) || '{}') || {}; } catch (error) { /* Storage is optional. */ }
        this.seen = new Set(Array.isArray(saved.seen) ? saved.seen.filter(id => this.byId.has(id)) : []);
        this.roundSeen = { find: new Set(), save: new Set() };
        for (const funnel of ['find', 'save']) {
          const round = saved.roundSeen && saved.roundSeen[funnel];
          if (Array.isArray(round)) this.roundSeen[funnel] = new Set(round.filter(key => this.breeds[funnel].has(key)));
        }
        this.phase = Number.isInteger(saved.phase) && saved.phase >= 0 && saved.phase < 3 ? saved.phase : this.seen.size % 3;
        this.lastId = typeof saved.lastId === 'string' && this.seen.has(saved.lastId) ? saved.lastId : '';
        if (this.lastId) this.paint(this.byId.get(this.lastId));
        this.updateStatus();
      }

      saveProgress() {
        try {
          sessionStorage.setItem(this.storageKey, JSON.stringify({
            seen: Array.from(this.seen),
            roundSeen: { find: Array.from(this.roundSeen.find), save: Array.from(this.roundSeen.save) },
            phase: this.phase,
            lastId: this.lastId
          }));
        } catch (error) { /* Continue within this page if storage is blocked. */ }
      }

      chooseNext() {
        if (this.seen.size === this.pups.length) {
          this.seen.clear();
          this.roundSeen.find.clear();
          this.roundSeen.save.clear();
          this.phase = 0;
        }
        const unseen = {};
        for (const funnel of ['find', 'save']) {
          unseen[funnel] = Array.from(this.breeds[funnel], ([key, pups]) => ({ key, pups: pups.filter(pup => !this.seen.has(pup.id)) }))
            .filter(group => group.pups.length);
        }
        const preferred = ['find', 'find', 'save'][this.phase];
        const funnel = unseen[preferred].length ? preferred : preferred === 'find' ? 'save' : 'find';
        const round = this.roundSeen[funnel];
        let eligible = unseen[funnel].filter(group => !round.has(group.key));
        if (!eligible.length) {
          round.clear();
          eligible = unseen[funnel];
        }
        // Avoid showing the same breed on consecutive spins when another breed
        // is eligible in the scheduled funnel's current round.
        const previous = this.byId.get(this.lastId);
        if (eligible.length > 1 && previous) eligible = eligible.filter(group => group.key !== previous.breedKey);
        const group = eligible[Math.floor(Math.random() * eligible.length)];
        if (!group) return null;
        const alternatives = group.pups.filter(pup => pup.id !== this.lastId);
        const candidates = alternatives.length ? alternatives : group.pups;
        return candidates[Math.floor(Math.random() * candidates.length)];
      }

      updateStatus() {
        this.statusText.setAttribute('data-phr-progress', '');
        const done = this.seen.size;
        const total = this.pups.length;
        this.spinButton.textContent = done === total ? 'START AGAIN' : done ? 'SPIN AGAIN' : 'FIND MY MATCH';
        this.statusText.textContent = done === total
          ? 'You’ve met all ' + total + (total === 1 ? ' pup. ' : ' pups. ') + 'Start again for a fresh shuffle.'
          : done ? 'Pups met: ' + done + ' of ' + total : 'Click to meet your first pup.';
      }

      paint(pup) {
        this.heading.hidden = false;
        this.nameText.textContent = (pup.funnel === 'find' ? 'This ' : '') + pup.title + ' Chose You';
        this.productLink.textContent = 'Look at ' + (pup.funnel === 'save' ? pup.title : pup.breed);
        this.productLink.setAttribute('aria-label', 'Look at ' + pup.breed + ' pup: ' + pup.title);
        this.productLink.href = pup.url;
        this.productLink.hidden = false;
        this.bottomStem.hidden = true;
        this.photo.hidden = true;
        this.photoFallback.hidden = true;
        if (pup.image) {
          this.photo.alt = pup.title + ' — ' + pup.breed;
          this.photo.src = pup.image;
          this.photo.hidden = false;
          this.mystery.hidden = true;
        } else {
          this.photo.removeAttribute('src');
          this.mystery.hidden = false;
          this.photoFallback.hidden = false;
        }
      }

      async turn(from, to, duration) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !this.card.animate) return;
        const animation = this.card.animate([
          { transform: 'rotateY(' + from + 'deg)' },
          { transform: 'rotateY(' + to + 'deg)' }
        ], { duration, easing: 'ease-in-out', fill: 'forwards' });
        try { await animation.finished; } catch (error) { /* Section removed during a flip. */ }
      }

      async revealNext() {
        if (this.busy || this.loading || !this.pups || !this.pups.length) return;
        this.busy = true;
        this.spinButton.disabled = true;
        this.card.setAttribute('aria-busy', 'true');
        this.productLink.setAttribute('aria-disabled', 'true');
        const signal = this.controller.signal;
        try {
          const pup = this.chooseNext();
          if (!pup) return;
          await this.turn(0, 90, 240);
          if (signal.aborted) return;
          this.card.getAnimations().forEach(animation => animation.cancel());
          this.paint(pup);
          await this.turn(-90, 0, 300);
          if (signal.aborted) return;
          this.seen.add(pup.id);
          this.roundSeen[pup.funnel].add(pup.breedKey);
          this.phase = (this.phase + 1) % 3;
          this.lastId = pup.id;
          this.saveProgress();
          this.updateStatus();
        } finally {
          if (this.controller.signal === signal) {
            this.card.getAnimations().forEach(animation => animation.cancel());
            this.card.removeAttribute('aria-busy');
            this.productLink.removeAttribute('aria-disabled');
            this.busy = false;
            if (!signal.aborted) this.spinButton.disabled = false;
          }
        }
      }
    }
    customElements.define('puppath-home-randomizer', PupPathHomeRandomizer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puppath-popular-breeds"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('puppath-popular-breeds')) {
    class PupPathPopularBreeds extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this._life = new AbortController();
        this._cache = new Map();
        this._sequence = 0;
        try {
          this.config = JSON.parse(this.querySelector('[data-pppb-config]').content.textContent);
        } catch (_) {
          this.status('The recommendation settings could not be read. Re-paste the complete section file.');
          return;
        }
        this.catalog = new Map(this.config.catalog.map(breed => [breed.key, breed]));
        this.editor = this.dataset.designMode === 'true' || Boolean(window.Shopify?.designMode);
        const root = new URL(this.dataset.shopRoot || window.Shopify?.routes?.root || '/', location.origin);
        this.shopRoot = root.origin === location.origin ? root : new URL('/', location.origin);
        if (!this.shopRoot.pathname.endsWith('/')) this.shopRoot.pathname += '/';
        const signal = this._life.signal;
        window.addEventListener('pageshow', event => {
          if (event.persisted) { this._cache.clear(); this.refresh(); }
        }, {signal});
        this.refresh();
      }

      disconnectedCallback() {
        this._connected = false;
        this._life?.abort();
        this._loading?.abort();
        this._sequence = (this._sequence || 0) + 1;
      }

      status(message) {
        const element = this.querySelector('[data-pppb-status]');
        if (!element) return;
        element.textContent = message;
        element.hidden = !message;
      }

      localURL(value, kind) {
        if (!value) return null;
        try {
          const url = new URL(value, this.shopRoot);
          if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
          if (!url.pathname.includes('/' + kind + '/')) return null;
          if (this.shopRoot.pathname !== '/' && !url.pathname.startsWith(this.shopRoot.pathname)) {
            url.pathname = this.shopRoot.pathname + url.pathname.replace(/^\/+/, '');
          }
          return url;
        } catch (_) { return null; }
      }

      async loadBreed(breed, signal) {
        if (this._cache.has(breed.key)) return this._cache.get(breed.key);
        const url = this.localURL(breed.url, 'collections');
        if (!url) return [];
        url.search = '';
        url.searchParams.set('sections', this.dataset.sectionId);
        const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
        if (previewTheme && /^\d+$/.test(previewTheme)) url.searchParams.set('preview_theme_id', previewTheme);
        const controller = new AbortController();
        const abort = () => controller.abort();
        signal.addEventListener('abort', abort, {once:true});
        if (signal.aborted) controller.abort();
        const timeout = setTimeout(abort, 12000);
        try {
          // Keep the normal page request format: application/json selects
          // collection metadata instead of section HTML on Shopify's route.
          const response = await fetch(url.href, {credentials:'same-origin', cache:'no-store', signal:controller.signal});
          if (!response.ok) throw new Error('Collection request failed');
          const sections = await response.json();
          const markup = sections[this.dataset.sectionId];
          if (typeof markup !== 'string') throw new Error('Section not available');
          const parsed = new DOMParser().parseFromString(markup, 'text/html');
          const feed = parsed.querySelector('template[data-pppb-feed]');
          if (!feed) throw new Error('Collection feed missing');
          const data = JSON.parse(feed.content.textContent);
          if (!Array.isArray(data.products)) throw new Error('Collection feed invalid');
          const otherFunnel = this.config.funnel === 'find-now' ? 'save-now' : 'find-now';
          const products = data.products.filter(pup => {
            if (!pup || !pup.id || pup.available !== true || !Array.isArray(pup.tags)) return false;
            if (!pup.tags.includes(this.config.funnel) || pup.tags.includes(otherFunnel) || !pup.tags.includes(breed.key)) return false;
            return typeof pup.image === 'string' && pup.image.includes('<img') && typeof pup.price === 'string' && this.localURL(pup.url, 'products');
          }).map(pup => ({...pup, breed:breed.key}));
          if (!signal.aborted) this._cache.set(breed.key, products);
          return products;
        } finally {
          clearTimeout(timeout);
          signal.removeEventListener('abort', abort);
        }
      }

      async refresh() {
        if (!this.config || !this.isConnected) return;
        const sequence = ++this._sequence;
        this._loading?.abort();
        this._loading = new AbortController();
        const signal = this._loading.signal;
        const view = this.querySelector('[data-pppb-view]');
        view.hidden = true;
        this.setAttribute('aria-busy', 'true');
        this.status('Loading your popular breeds…');
        const seen = new Set();
        const chosen = [];
        const missing = [];
        const failed = [];
        // Exactly one card per ranked breed. Never fill a gap with another
        // puppy of an already displayed breed. Two requests at a time.
        for (let start = 0; start < this.config.catalog.length; start += 2) {
          const breeds = this.config.catalog.slice(start, start + 2);
          const batch = await Promise.allSettled(breeds.map(breed => this.loadBreed(breed, signal)));
          if (signal.aborted || sequence !== this._sequence || !this.isConnected) return;
          batch.forEach((result, index) => {
            const breed = breeds[index];
            if (result.status !== 'fulfilled') { failed.push(breed.name); return; }
            let card = null;
            for (const pup of result.value) {
              const id = String(pup.id);
              if (seen.has(id)) continue;
              card = this.makeCard(pup);
              if (!card) continue;
              seen.add(id);
              chosen.push(card);
              break;
            }
            if (!card) missing.push(breed.name);
          });
        }
        if (signal.aborted || sequence !== this._sequence || !this.isConnected) return;
        this.querySelector('[data-pppb-heading]').textContent = this.config.heading;
        this.querySelector('[data-pppb-row-one]').replaceChildren(...chosen.slice(0, 4));
        this.querySelector('[data-pppb-row-two]').replaceChildren(...chosen.slice(4, 8));
        this.querySelector('[data-pppb-row-three]').replaceChildren(...chosen.slice(8, 12));
        this.querySelector('[data-pppb-divider]').hidden = chosen.length <= 4;
        this.querySelector('[data-pppb-second]').hidden = chosen.length <= 4;
        this.querySelector('[data-pppb-divider-two]').hidden = chosen.length <= 8;
        this.querySelector('[data-pppb-third]').hidden = chosen.length <= 8;
        view.hidden = chosen.length === 0;
        this.setAttribute('aria-busy', 'false');
        const messages = [];
        if (missing.length) messages.push('No eligible puppy found for: ' + missing.join(', ') + '. Check the published ' + this.config.funnel + ' breed collections, matching product tags, availability, and photos.');
        if (failed.length) messages.push('Could not load: ' + failed.join(', ') + '. Refresh the preview to retry.');
        this.status(messages.length ? chosen.length + ' of 12 breeds displayed. ' + messages.join(' ') : '');
      }

      replaceBreed(text, name) { return String(text || '').replace(/\[breed\]|\(breed\)/gi, name); }

      makeCard(pup) {
        const breed = this.catalog.get(pup.breed);
        const url = this.localURL(pup.url, 'products');
        if (!breed || !url) return null;
        const imageTemplate = document.createElement('template');
        imageTemplate.innerHTML = pup.image;
        const sourceImage = imageTemplate.content.querySelector('img');
        if (!sourceImage) return null;
        let imageURL;
        try { imageURL = new URL(sourceImage.getAttribute('src'), location.origin); } catch (_) { return null; }
        if (!/^https?:$/.test(imageURL.protocol)) return null;
        const item = document.createElement('li');
        item.className = 'pppb__item';
        item.dataset.productId = String(pup.id);
        item.dataset.breed = breed.key;
        const link = document.createElement('a');
        link.className = 'pppb__card';
        link.href = url.href;
        link.setAttribute('aria-label', 'View ' + pup.title + ', ' + breed.name);
        const photo = document.createElement('div');
        photo.className = 'pppb__photo';
        const image = document.createElement('img');
        image.className = 'pppb__image';
        image.src = imageURL.href;
        for (const attribute of ['srcset', 'sizes', 'width', 'height']) {
          const value = sourceImage.getAttribute(attribute);
          if (value) image.setAttribute(attribute, value);
        }
        image.alt = pup.title + ' — ' + breed.name;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.style.objectPosition = sourceImage.style.objectPosition || '50% 50%';
        photo.append(image);
        const price = document.createElement('p');
        price.className = 'pppb__price';
        price.textContent = (pup.priceVaries ? 'From ' : '') + pup.price;
        const copy = document.createElement('p');
        copy.className = 'pppb__copy';
        copy.textContent = this.replaceBreed(this.config.copy, breed.name);
        const button = document.createElement('span');
        button.className = 'pppb__button';
        button.textContent = 'Look at the ' + breed.name;
        link.append(photo, price, copy, button);
        item.append(link);
        return item;
      }
    }
    customElements.define('puppath-popular-breeds', PupPathPopularBreeds);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puppath-puppy-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('puppath-puppy-stories')) {
    class PupPathPuppyStories extends HTMLElement {
      connectedCallback() {
        if (this._scrollLife) return;
        this._scrollLife = new AbortController();
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-ppps-top]');
          if (!link || !this.contains(link) || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
          // Scroll the storefront document, including inside Shopify's preview.
          // Also handle a theme that places the product in a scrolling container.
          let ancestor = this.parentElement;
          while (ancestor && ancestor !== document.body && ancestor !== document.documentElement) {
            if (ancestor.scrollHeight > ancestor.clientHeight + 1 && /auto|scroll|overlay/.test(getComputedStyle(ancestor).overflowY)) {
              ancestor.scrollTo({ top: 0, behavior });
            }
            ancestor = ancestor.parentElement;
          }
          window.scrollTo({ top: 0, behavior });
        }, { signal: this._scrollLife.signal });
      }
      disconnectedCallback() {
        this._scrollLife?.abort();
        this._scrollLife = null;
      }
    }
    customElements.define('puppath-puppy-stories', PupPathPuppyStories);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puppath-save-randomizer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('puppath-save-randomizer')) {
    class PupPathSaveRandomizer extends HTMLElement {
      connectedCallback() {
        if (this._running) return;
        this._running = true;
        this.controller = new AbortController();
        this.spinButton = this.querySelector('[data-ppr-spin]');
        this.statusText = this.querySelector('[data-ppr-status]');
        this.card = this.querySelector('[data-ppr-card]');
        this.heading = this.querySelector('[data-ppr-heading]');
        this.nameText = this.querySelector('[data-ppr-name]');
        this.mystery = this.querySelector('[data-ppr-mystery]');
        this.photo = this.querySelector('[data-ppr-photo]');
        this.photoFallback = this.querySelector('[data-ppr-photo-fallback]');
        this.productLink = this.querySelector('[data-ppr-link]');
        this.bottomStem = this.querySelector('[data-ppr-bottom-stem]');
        if (!this.spinButton || !this.card) { this._running = false; return; }
        this.spinButton.addEventListener('click', () => {
          if (this.failed) this.loadCatalog();
          else this.revealNext();
        }, { signal: this.controller.signal });
        this.productLink.addEventListener('click', event => {
          if (this.busy) event.preventDefault();
        }, { signal: this.controller.signal });
        this.photo.addEventListener('error', () => {
          this.photo.hidden = true;
          this.mystery.hidden = false;
          this.photoFallback.hidden = false;
        }, { signal: this.controller.signal });
        this.loadCatalog();
      }

      disconnectedCallback() {
        this._running = false;
        if (this.controller) this.controller.abort();
        this.loading = false;
        this.busy = false;
        if (this.card) this.card.getAnimations().forEach(animation => animation.cancel());
      }

      async loadCatalog() {
        if (this.loading) return;
        this.loading = true;
        this.failed = false;
        this.spinButton.disabled = true;
        this.spinButton.textContent = 'FIND MY MATCH';
        this.statusText.removeAttribute('data-ppr-progress');
        this.statusText.textContent = 'Getting the pups ready…';
        const signal = this.controller.signal;
        try {
          const first = JSON.parse(this.querySelector('[data-ppr-catalog]').textContent);
          if (!first.collectionId) {
            this.statusText.textContent = this.dataset.editor === 'true'
              ? 'Select your Save Now — All Pups collection in this section’s settings.'
              : 'Pups are on their way. Please check back soon.';
            return;
          }
          if (!Array.isArray(first.products) || !Number.isInteger(first.pages) || first.pages < 0 || first.pages > 500) throw new Error('Invalid catalog');
          const all = new Map();
          const pages = Math.max(1, first.pages);
          for (let page = 1; page <= pages; page++) {
            const payload = page === first.page ? first : await this.fetchPage(page, first, signal);
            for (const pup of payload.products) {
              if (!pup || typeof pup.id !== 'string' || typeof pup.title !== 'string' || !pup.title) continue;
              const destination = new URL(pup.url, window.location.origin);
              if (destination.origin !== window.location.origin || !destination.pathname.includes('/products/')) continue;
              all.set(pup.id, { ...pup, url: destination.href });
            }
          }
          if (signal.aborted) return;
          this.pups = Array.from(all.values());
          if (!this.pups.length) {
            this.statusText.textContent = this.dataset.editor === 'true'
              ? 'No Save Now pups found. Include the save-now tag in this collection and publish it and its products to Online Store.'
              : 'There are no pups to show here yet. Please check back soon.';
            return;
          }
          this.storageKey = 'puppath-save-randomizer-v1:' + first.collectionId;
          this.restoreProgress();
          this.spinButton.disabled = false;
        } catch (error) {
          if (signal.aborted) return;
          this.failed = true;
          this.spinButton.disabled = false;
          this.spinButton.textContent = 'TRY AGAIN';
          this.statusText.textContent = this.dataset.editor === 'true'
            ? 'The full puppy list could not load. Save the section and collection selection, check Online Store publication, then try again in storefront Preview.'
            : 'The pups could not load just now. Please try again.';
        } finally {
          if (this.controller.signal === signal) this.loading = false;
        }
      }

      async fetchPage(page, initial, parentSignal) {
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set(initial.pageParam || 'page', String(page));
        const request = new AbortController();
        const abort = () => request.abort();
        parentSignal.addEventListener('abort', abort, { once: true });
        const timeout = setTimeout(abort, 15000);
        try {
          if (parentSignal.aborted) throw new Error('Aborted');
          const response = await fetch(url.href, { credentials: 'same-origin', signal: request.signal });
          if (!response.ok) throw new Error('Section request failed');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const instance = Array.from(documentFragment.querySelectorAll('puppath-save-randomizer'))
            .find(element => element.dataset.sectionId === this.dataset.sectionId);
          const data = instance && instance.querySelector('[data-ppr-catalog]');
          if (!data) throw new Error('Section data missing');
          const payload = JSON.parse(data.textContent);
          if (payload.collectionId !== initial.collectionId || payload.page !== page || payload.pages !== initial.pages || !Array.isArray(payload.products)) throw new Error('Catalog changed');
          return payload;
        } finally {
          clearTimeout(timeout);
          parentSignal.removeEventListener('abort', abort);
        }
      }

      shuffle(list) {
        const result = list.slice();
        for (let i = result.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [result[i], result[j]] = [result[j], result[i]];
        }
        return result;
      }

      restoreProgress() {
        let saved = {};
        try { saved = JSON.parse(sessionStorage.getItem(this.storageKey) || '{}') || {}; } catch (error) { /* Storage is optional. */ }
        const current = new Set(this.pups.map(pup => pup.id));
        this.seen = new Set(Array.isArray(saved.seen) ? saved.seen.filter(id => current.has(id)) : []);
        this.lastId = typeof saved.lastId === 'string' && current.has(saved.lastId) ? saved.lastId : '';
        this.remaining = this.shuffle(this.pups.filter(pup => !this.seen.has(pup.id)));
        if (this.lastId && this.seen.has(this.lastId)) this.paint(this.pups.find(pup => pup.id === this.lastId));
        this.updateStatus();
      }

      saveProgress() {
        try { sessionStorage.setItem(this.storageKey, JSON.stringify({ seen: Array.from(this.seen), lastId: this.lastId })); } catch (error) { /* Continue within this page if storage is blocked. */ }
      }

      updateStatus() {
        this.statusText.setAttribute('data-ppr-progress', '');
        const done = this.seen.size;
        const total = this.pups.length;
        this.spinButton.textContent = done === total ? 'START AGAIN' : done ? 'SPIN AGAIN' : 'FIND MY MATCH';
        this.statusText.textContent = done === total
          ? 'You’ve met all ' + total + (total === 1 ? ' pup. ' : ' pups. ') + 'Start again for a fresh shuffle.'
          : done ? 'Pups met: ' + done + ' of ' + total : 'Click to meet your first pup.';
      }

      paint(pup) {
        this.heading.hidden = false;
        this.nameText.textContent = pup.title + ' Chose You';
        this.productLink.textContent = 'Look at ' + pup.title;
        this.productLink.href = pup.url;
        this.productLink.hidden = false;
        this.bottomStem.hidden = true;
        this.photo.hidden = true;
        this.photoFallback.hidden = true;
        if (pup.image) {
          this.photo.alt = pup.title;
          this.photo.src = pup.image;
          this.photo.hidden = false;
          this.mystery.hidden = true;
        } else {
          this.photo.removeAttribute('src');
          this.mystery.hidden = false;
          this.photoFallback.hidden = false;
        }
      }

      async turn(from, to, duration) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !this.card.animate) return;
        const animation = this.card.animate([
          { transform: 'rotateY(' + from + 'deg)' },
          { transform: 'rotateY(' + to + 'deg)' }
        ], { duration, easing: 'ease-in-out', fill: 'forwards' });
        try { await animation.finished; } catch (error) { /* Section removed during a flip. */ }
      }

      async revealNext() {
        if (this.busy || this.loading || !this.pups || !this.pups.length) return;
        this.busy = true;
        this.spinButton.disabled = true;
        this.card.setAttribute('aria-busy', 'true');
        this.productLink.setAttribute('aria-disabled', 'true');
        const signal = this.controller.signal;
        try {
          if (!this.remaining.length) {
            this.seen.clear();
            this.remaining = this.shuffle(this.pups);
            if (this.remaining.length > 1 && this.remaining[this.remaining.length - 1].id === this.lastId) {
              [this.remaining[0], this.remaining[this.remaining.length - 1]] = [this.remaining[this.remaining.length - 1], this.remaining[0]];
            }
          }
          const pup = this.remaining[this.remaining.length - 1];
          await this.turn(0, 90, 240);
          if (signal.aborted) return;
          this.card.getAnimations().forEach(animation => animation.cancel());
          this.paint(pup);
          await this.turn(-90, 0, 300);
          if (signal.aborted) return;
          this.remaining.pop();
          this.seen.add(pup.id);
          this.lastId = pup.id;
          this.saveProgress();
          this.updateStatus();
        } finally {
          if (this.controller.signal === signal) {
            this.card.getAnimations().forEach(animation => animation.cancel());
            this.card.removeAttribute('aria-busy');
            this.productLink.removeAttribute('aria-disabled');
            this.busy = false;
            if (!signal.aborted) this.spinButton.disabled = false;
          }
        }
      }
    }
    customElements.define('puppath-save-randomizer', PupPathSaveRandomizer);
  }

  } catch(e) { console.error(e); }
})();
})();
